export default {"src":"/_next/static/media/PrincipalPositivaPurple.185a9cd1.svg","height":531,"width":1291};